import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      closeButton={true}
      icons={{
        success: <CircleCheckIcon className="size-4 text-success-foreground" />,
        info: <InfoIcon className="size-4 text-info-foreground" />,
        warning: (
          <TriangleAlertIcon className="size-4 text-warning-foreground" />
        ),
        error: <OctagonXIcon className="size-4 text-destructive-foreground" />,
        loading: (
          <Loader2Icon className="size-4 animate-spin text-primary-foreground" />
        ),
      }}
      toastOptions={{
        classNames: {
          error:
            "!bg-destructive !text-destructive-foreground !border-destructive",
          warning: "!bg-warning !text-warning-foreground !border-warning",
          success: "!bg-success !text-success-foreground !border-success",
          info: "!bg-primary !text-primary-foreground !border-primary",
          loading: "!bg-primary !text-primary-foreground !border-primary",
        },
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
